import type { AdminUserRoles_ScopeLevel as AdminUserRolesScopeLevel } from '__generated__/graphql-types';

export interface StaffManagementScopeData {
  scopeLevel: AdminUserRolesScopeLevel;
  scopeId: string;
  scopeName: string;
  parentScopeId?: string;
  parentScopeName?: string;
}

export const StaffPermissionsLoadingEventName = {
  UserProfile: 'staff_permissions_user_profile_load',
  UserRoles: 'staff_permissions_user_roles_load',
} as const;

export type StaffPermissionsLoadingEventNameType =
  (typeof StaffPermissionsLoadingEventName)[keyof typeof StaffPermissionsLoadingEventName];
